import { instanceRef } from '../utils/axios';

export const marcasFetcher = async () => {
  const response = await instanceRef.instance.get(`data/marcas`);
  const orderedMarcas = response.data.data.sort(function test(a, b) {
    if (a.descripcion < b.descripcion) {
      return -1;
    }
    if (a.descripcion > b.descripcion) {
      return 1;
    }
    return 0;
  });
  return orderedMarcas;
};

export const modelosFetcher = async (marca) => {
  if (!marca) {
    return [];
  }
  const response = await instanceRef.instance.get(`data/modelos`, {
    params: { marca }
  });
  const orderedModelos = response.data.data
    ? response.data.data.sort(function test(a, b) {
        if (a.descripcion < b.descripcion) {
          return -1;
        }
        if (a.descripcion > b.descripcion) {
          return 1;
        }
        return 0;
      })
    : [];
  return orderedModelos;
};

export const submodelosFetcher = async (
  marcaSelected,
  modeloSelected,
  anioSelected
) => {
  if (!marcaSelected || !modeloSelected || !anioSelected) {
    return [];
  }
  const response = await instanceRef.instance.get(`data/submodelos`, {
    params: {
      marca: marcaSelected,
      modelo: modeloSelected,
      anio: anioSelected
    }
  });
  const orderedSubmodelos = response.data.data
    ? response.data.data.sort(function test(a, b) {
        if (a.descripcion < b.descripcion) {
          return -1;
        }
        if (a.descripcion > b.descripcion) {
          return 1;
        }
        return 0;
      })
    : [];
  return orderedSubmodelos;
};

export const aniosFetcher = async (marcaSelected, modeloSelected) => {
  if (!marcaSelected || !modeloSelected) {
    return [];
  }
  const response = await instanceRef.instance.get(`data/anios`, {
    params: { marca: marcaSelected, modelo: modeloSelected }
  });
  const orderedAnios = response.data.data
    ? response.data.data.sort(function test(a, b) {
        if (Number(a.descripcion) < Number(b.descripcion)) {
          return 1;
        }
        if (Number(a.descripcion) > Number(b.descripcion)) {
          return -1;
        }
        return 0;
      })
    : [];
  return orderedAnios;
};

export const departamentosFetcher = async () => {
  const response = await instanceRef.instance.get(`data/departamentos`);
  const orderedDepartamentos = response.data.data.sort(function test(a, b) {
    if (a.descripcion < b.descripcion) {
      return -1;
    }
    if (a.descripcion > b.descripcion) {
      return 1;
    }
    return 0;
  });
  return orderedDepartamentos;
};

export const distritosFetcher = async (departamento) => {
  if (departamento) {
    const response = await instanceRef.instance.get(
      `data/distritos?departamento=${departamento}`
    );
    const orderedDistritos = response.data.data.sort(function test(a, b) {
      if (a.descripcion < b.descripcion) {
        return -1;
      }
      if (a.descripcion > b.descripcion) {
        return 1;
      }
      return 0;
    });
    return orderedDistritos;
  }
  return [];
};
